import BaseVueComponent from "common/BaseVueComponent"
import { Component, Prop, Watch } from "vue-property-decorator"

@Component
export default class FButtonToggleBase extends BaseVueComponent {
    @Prop() public toggleValue!: string[] | string
    @Prop({ default: false, type: Boolean }) public disabled!: boolean
    @Prop({ default: [], type: Array }) public optionList!: string[]
    @Prop({
        default: function () {
            return [""]
        },
        type: [Array, String]
    })
    public disabledOptions!: string[]
    @Prop({ default: "", type: String }) public activeClass!: string
    @Prop({ default: false, type: Boolean }) public showButton!: boolean
    @Prop({ default: false, type: Boolean }) public multiple!: boolean
    @Prop({ default: false, type: Boolean }) public small!: boolean
    @Prop({ default: false, type: Boolean }) public isMultipleView!: boolean

    public selectedOption: string | null = null

    public get localToggle(): string[] | string {
        return this.toggleValue
    }

    public set localToggle(toggle: string[] | string) {
        this.$emit("change", toggle)
    }

    public get localSingleToggle(): string | null {
        return this.selectedOption
    }

    /**
     * Single-select mode: v-btn-toggle deselects the active button when it is clicked again, so emit
     * `buttonDeselect` in that case instead of re-emitting `buttonClick` for an option that is no longer selected.
     */
    public set localSingleToggle(option: string | null) {
        const previous = this.selectedOption
        this.selectedOption = option ?? null
        if (option) this.$emit("buttonClick", option)
        else if (previous) this.$emit("buttonDeselect", previous)
    }

    /**
     * Single-select mode: lets the parent drive the selected option through `toggleValue`, e.g. clearing the
     * highlighted preset when it clears or hand-edits the dates the preset applied.
     */
    @Watch("toggleValue", { immediate: true })
    public syncSingleToggle(): void {
        if (this.multiple || this.isMultipleView) return
        this.selectedOption = typeof this.toggleValue === "string" && this.toggleValue ? this.toggleValue : null
    }

    public buttonClick(range: string | string) {
        // Single-select clicks are emitted from localSingleToggle once the toggle state has changed
        if (this.multiple || this.isMultipleView) this.$emit("buttonClick", range)
    }

    public isButtonDisabled(option: string): boolean {
        return this.disabledOptions.includes(option)
    }
}
